import { CommonModule } from '@angular/common'
import { Component, EventEmitter, inject } from '@angular/core'
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule } from '@angular/material/bottom-sheet'
/**
 * Represents a list of zones as a mat bottom sheet
 */
@Component({
  selector: 'ngx-zones-sheet-bottom',
  templateUrl: './zones-sheet-bottom.component.html',
  styleUrls: ['./zones-sheet-bottom.component.scss'],
  standalone: true,
  imports: [CommonModule, MatBottomSheetModule]
})
export class ZonesSheetBottomComponent {
  protected readonly data = inject(MAT_BOTTOM_SHEET_DATA) as { zone: any; zones: any; selectedZone: EventEmitter<any> }

  /**
   * emits current active zone
   * @param item Zone
   */
  activeZone(item) {
    this.data.selectedZone.emit(item)
  }

  /**
   * Is the provided zone slug the current zone slug
   * @param slug string
   * @returns boolean
   */
  isZone(slug): boolean {
    return this.data.zone === '#all$' ? this.data.zone === slug : this.data.zone.slug === slug
  }
}
